import "../../styles/Cards.css";
import Navbar from "../../components/Navbar";
import TopNavbar2side from "../../components/TopNavbar2side";
import "../../styles/Buttons.css";
import "../../styles/Containers.css";
import "../../styles/Colors.css";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import GoToTop from "../../components/GoToTop";
import { useFetch } from "../../custom/api";
import { useEffect, useState } from "react";
import Card from "../../components/Card";
import TopNavbarBack from "../../components/TopNavbarBack";
import LoadingPage from "../../components/LoadingPage";
import EmptyComp from "../../components/EmptyComp";

export function OneCategorySearch(props) {
  const { title, tagHref, foods } = props;

  return (
    <div className="category">
      <div className="spc-between">
        <p className="heading-2">{title}</p>
      </div>
      <div className="card-row">
        {foods.map((card) => {
          return <Card card={card} key={card.recipe_id} />;
        })}
      </div>
    </div>
  );
}

const Search = () => {
  const { myFetch } = useFetch();
  let [searchParams, setSearchParams] = useSearchParams();
  let queryParameter = searchParams.get("q");
  const [recipes, setRecipes] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const resp = await myFetch(`search?q=${queryParameter}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const r = await resp.json();
      setRecipes(r);
    };
    console.log(queryParameter.length);
    if (queryParameter.length > 2) {
      fetchData();
    }
  }, []);

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
    <div className="fixedPosition index">
      <TopNavbarBack
        title=""
        rbuttonIcon={["icon-iconchevron-right"]}
        rbackground={["rectangle3"]}
        lbuttonIcon={["dNone"]}
        lbuttonHref={["null"]}
        lbackground={["null"]}
      />
      </div>

      <div className="main-container">
        {recipes === null ? (
          <LoadingPage />
        ) : Object.keys(recipes).length === 0 ? (
          <EmptyComp caption="غذایی با این کلمه پیدا نشد!"></EmptyComp>
        ) : (
          <div className="marginTop30">
            {recipes.map((recipe) => {
              return (
                <OneCategorySearch
                  key={Math.random()}
                  title={recipe.tag_name}
                  tagHref={recipe.foods[0].tag_id}
                  foods={recipe.foods}
                />
              );
            })}
          </div>
        )}

        {/* <Link to="/addCard" className="float white b-purple-1">
          <span className="icon-iconplus"></span>
        </Link> */}
      </div>

      <Navbar />

      <GoToTop />
    </>
  );
};

export default Search;
